module.exports = __webpack_public_path__ + "static/media/gryllodes_sigillatus.2df11096.png";